import React from 'react';
import { makeStyles } from '@material-ui/core';
import config from '@/configs/config';

const useStyles = makeStyles((theme) => ({
  root: {
    background: ({ readOnly }) => (readOnly ? 'transparent' : '#fff8e6'),
    borderRadius: ({ readOnly }) => (readOnly ? 0 : 8),
    boxShadow: ({ readOnly }) => (readOnly ? 0 : '0 0 5px 0 rgba(157,157,157,.5)'),
    display: 'flex',
    fontSize: 14,
    padding: ({ readOnly }) => (readOnly ? 0 : theme.spacing(1, 2)),
  },
  imageContainer: {
    alignItems: 'center',
    display: 'flex',
    maxWidth: 200,
    flexShrink: 3,
    flexBasis: '30%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),

    '&.$left': {
      flexGrow: 1,
      flexBasis: 0,

      '& > *+*': {
        marginTop: theme.spacing(0.5),
      },

      '& .$name': {
        color: '#b20000',
        fontSize: 16,
        fontWeight: 'bold',
      },
      '& .$value': {
        fontWeight: 'bold',
        marginTop: 'auto',
      },
    },

    '&.$right': {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      fontWeight: 'bold',
      justifyContent: 'center',
      padding: theme.spacing(1),
    },
  },
  buyButton: {
    display: ({ readOnly }) => (readOnly ? 'none' : 'line'),
    background: '#ffd900',
    border: 0,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 'bold',
    outline: 'none',
    padding: theme.spacing(0.5, 1.25),
  },
  price: {
    color: '#b20000',
    fontSize: 18,
    marginTop: theme.spacing(1),
  },
}));

export default ({
  data,
  onBuyButtonClick: propsOnBuyButtonClick,
  readOnly,
}) => {
  const classes = useStyles({
    readOnly: readOnly || false,
  });
  const {
    coverImageUrl,
    description,
    id,
    name,
    price,
    value,
  } = data || {};

  const onBuyButtonClick = () => propsOnBuyButtonClick(id);

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <img src={`${config.RESOURCE_URI}${coverImageUrl}`} alt="" width="100%" />
      </div>
      <div className={[classes.content, 'left'].join(' ')}>
        <div className="name">{name || ''}</div>
        <div className="description">{description || ''}</div>
        <div className="value">{`折扣總價值${(value || 0).toLocaleString()}`}</div>
      </div>
      <div className={[classes.content, 'right'].join(' ')}>
        <button type="button" className={classes.buyButton} onClick={onBuyButtonClick}>購買</button>
        <div className={classes.price}>{`$${price}`}</div>
      </div>
    </div>
  );
};
